<section class="container py-2">
	<form class="row" #booster="ngForm">
		<div class="col-12 col-md-3">
			<div class="d-flex mb-1">
				<div class="no-wrap ml-2">کد آگهی:</div>
				<input type="number" inputmode="numeric" class="form-control" required name="code"
					placeholder="کد آگهی جهت ارسال ایمیل و پیامک" [(ngModel)]="payload.JobCode" (input)="loadJob()">
			</div>
			<div *ngIf="job">
				آگهی: <a [href]="'/job/' + job.Id" target="_blank" class="btn-link">{{job.Title}}</a>
			</div>
			<label class="d-flex mb-1">
				<input type="checkbox" name="promoted" [(ngModel)]="promoted" />
				<span>فقط کارجویان پیشتاز</span>
			</label>
			<label class="d-flex mb-1">
				<input type="checkbox" name="resend" [(ngModel)]="resend" />
				<span>ارسال مجدد</span>
				<form-hint class="mx-2">
					ارسال مجدد برای کارجویانی که قبلا این آگهی را دریافت کرده اند 
				</form-hint>

			</label>
			<label class="d-flex mb-1">
				<input type="checkbox" name="verified-email" [(ngModel)]="verifiedEmail" />
				<span>فقط ایمیل تایید شده</span>
				<form-hint class="mx-2">
					در صورتی که تعداد ایمیل های
					تایید شده کافی نبود این گزینه تغییر کند. قبل از استفاده با تیم فنی هماهنگ کنید
				</form-hint>
			</label>
			<div class="mb-1">
				<div>شهر یا استان: </div>
				<app-location name="location" [(ngModel)]="payload.Criteria.Seeker" required accept-level="Globe">
				</app-location>
			</div>
			<div class="mb-1">
				<div>جنسیت: </div>
				<select title="جنسیت" [(ngModel)]="payload.Criteria.Seeker.Gender" name="gender">
					<option [value]="-1">جنسیت</option>
					<option [value]="0">آقا</option>
					<option [value]="1">خانم</option>
				</select>
			</div>
			<div class="mb-1">
				<div>تحصیلات: </div>
				<select [(ngModel)]="payload.Criteria.Seeker.Degrees[0]" name="degree">
					<option value="">همه مقاطع</option>
					<option>زیر دیپلم</option>
					<option>دیپلم</option>
					<option>کاردانی</option>
					<option>کارشناسی</option>
					<option>کارشناسی‌ارشد</option>
					<option>دکترا</option>
				</select>
			</div>
			<div class="mb-1">
				کلمات کلیدی:
				<input type="text" [(ngModel)]="payload.Criteria.Seeker.Keyword" name="keyword" placeholder="کلمات کلیدی" />
			</div>
			<div class="mb-1">
				<div>بروزرسانی شده بعد از: </div>
				<app-calendar name="last-update" [(ngModel)]="payload.Criteria.Seeker.LastUpdateFrom"></app-calendar>
			</div>
			<!-- <div class="d-flex mb-1">
				<div>آخرین ارسال قبل از :</div>
				<app-calendar name="last-alert" [(ngModel)]="payload.Criteria.Seeker.JobAlert.LastAlertDateTo"></app-calendar>
			</div> -->
			<div class="mb-1">
				<div class="no-wrap ml-2">مرتب سازی: </div>
				<select title="مرتب سازی" [(ngModel)]="payload.Criteria.Sort" name="sort">
					<option [value]="UserSortType.Score">مرتبط ترین</option>
					<option [value]="UserSortType.ResumeUpdateTime">تاریخ ویرایش</option>
				</select>
			</div>
			<label class="mb-1">
				ساعت ارسال:
				<input type="number" inputmode="numeric" [(ngModel)]="payload.SendHour" name="sendhour" min="0" max="23" />
			</label>
		</div>
		<div class="col-12 col-md-9 border-right border-dark-gray border-2">
			<div class="py-2 border-bottom border-dark-gray border-2 my-2" [class.x-light-gray-bg]="!view.jobTitle_new">
				<h6 class="btn btn-link fs-lg text-center w-100" (click)="view.jobTitle_new=!view.jobTitle_new">عنوان شغلی جدید</h6>
				<ng-container *ngIf="view.jobTitle_new">
					<div class="d-flex mb-1">
						<div class="flex-grow-1 ml-2">
							<ng-select name="job-title-new" [multiple]="true" [items]="jobTitles_new" [virtualScroll]="true"
								bindValue="Title" bindLabel="Title" [(ngModel)]="payload.JobTitles_New" [selectOnTab]="true"
								placeholder="عنوان شغلی" class="w-100">
							</ng-select>
						</div>
						<div>
							<button class="btn btn-white" (click)="search('jobTitles_new')">جستجو</button>
						</div>
					</div>
					<table class="w-100 text-center">
						<tr>
							<td></td>
							<td>رزومه</td>
							<td>تعداد ارسال</td>
							<td></td>
							<td>ثبت شده</td>
						</tr>
						<tr class="pb-1 mb-1 border-top">
							<td>پیامک</td>
							<td>{{searchCounts.jobTitles_new_sms | number}}</td>
							<td><input type="number" inputmode="numeric" name="jobTitleNewSmsSendCount"
									[(ngModel)]="sendCount.jobTitleNewSms" min="0" value="0" /> </td>
							<td><button class="btn btn-blue fs-sm" (click)="send('jobTitle_new', 'Sms', sendCount.jobTitleNewSms)"
									[disabled]="!booster.valid || !+(sendCount.jobTitleNewSms)">ارسال</button>
							</td>
							<td>{{sentCount.jobTitle_new?.Sms | number}}</td>
						</tr>
						<tr class="pb-1 mb-1 border-top">
							<td>ایمیل</td>
							<td>{{searchCounts.jobTitles_new_email | number}}</td>
							<td><input type="number" inputmode="numeric" name="jobTitleNewEmailSendCount"
									[(ngModel)]="sendCount.jobTitleNewjobTitleEmail" min="0" value="0" /> </td>
							<td><button class="btn btn-blue fs-sm"
									(click)="send('jobTitle_new', 'Email', sendCount.jobTitleNewjobTitleEmail)"
									[disabled]="!booster.valid || !+(sendCount.jobTitleNewjobTitleEmail)">ارسال</button> </td>
							<td>{{sentCount.jobTitle_new?.Email | number}}</td>
						</tr>
					</table>
				</ng-container>
			</div>

			<div class="py-2 border-bottom border-dark-gray border-2 my-2" [class.x-light-gray-bg]="!view.jobTitles">
				<h6 class="btn btn-link fs-lg text-center w-100" (click)="view.jobTitles=!view.jobTitles">عنوان شغلی قدیمی</h6>
				<ng-container *ngIf="view.jobTitles">

					<div class="d-flex mb-1">
						<div class="flex-grow-1 ml-2">
							<ng-select name="job-title" [multiple]="true" [items]="jobTitles" [virtualScroll]="true"
								bindValue="Header" bindLabel="Header" [(ngModel)]="payload.Criteria.Seeker.JobTitles"
								[selectOnTab]="true" placeholder="عنوان شغلی" class="w-100">
							</ng-select>
						</div>
						<div>
							<button class="btn btn-white" (click)="search('jobTitle')">جستجو</button>
						</div>
					</div>
					<table class="w-100 text-center">
						<tr>
							<td></td>
							<td>رزومه</td>
							<td>تعداد ارسال</td>
							<td></td>
							<td>ثبت شده</td>
						</tr>
						<tr class="pb-1 mb-1 border-top">
							<td>پیامک</td>
							<td>{{searchCounts.jobTitle_sms | number}}</td>
							<td><input type="number" inputmode="numeric" name="jobTitleSmsSendCount"
									[(ngModel)]="sendCount.jobTitleSms" min="0" value="0" /> </td>
							<td><button class="btn btn-blue fs-sm" (click)="send('jobTitle', 'Sms', sendCount.jobTitleSms)"
									[disabled]="!booster.valid || !+(sendCount.jobTitleSms)">ارسال</button>
							</td>
							<td>{{sentCount.jobTitle?.Sms | number}}</td>
						</tr>
						<tr class="pb-1 mb-1 border-top">
							<td>ایمیل</td>
							<td>{{searchCounts.jobTitle_email | number}}</td>
							<td><input type="number" inputmode="numeric" name="jobTitleEmailSendCount"
									[(ngModel)]="sendCount.jobTitlejobTitleEmail" min="0" value="0" /> </td>
							<td><button class="btn btn-blue fs-sm"
									(click)="send('jobTitle', 'Email', sendCount.jobTitlejobTitleEmail)"
									[disabled]="!booster.valid || !+(sendCount.jobTitlejobTitleEmail)">ارسال</button> </td>
							<td>{{sentCount.jobTitle?.Email | number}}</td>
						</tr>
					</table>
				</ng-container>

			</div>
			<div class="py-2 border-bottom border-dark-gray border-2 my-2" [class.x-light-gray-bg]="!view.fields">
				<h6 class="btn btn-link fs-lg text-center w-100" (click)="view.fields=!view.fields">رشته تحصیلی</h6>
				<ng-container *ngIf="view.fields">
					<div class="d-flex mb-1">
						<div class="flex-grow-1 ml-2">
							<ng-select name="fields" [multiple]="true" [addTag]="false" [items]="fields" [virtualScroll]="true"
								[selectOnTab]="true" [(ngModel)]="payload.Criteria.Seeker.Fields"
								placeholder="انتخاب رشته‌های تحصیلی مورد نیاز" typeToSearchText="رشته مورد نظر را جستجو و انتخاب کنید">
							</ng-select>
						</div>
						<div>
							<button class="btn btn-white" (click)="search('field')">جستجو</button>
						</div>
					</div>
					<table class="w-100 text-center">
						<tr>
							<td></td>
							<td>رزومه</td>
							<td>تعداد ارسال</td>
							<td></td>
							<td>ثبت شده</td>
						</tr>
						<tr class="pb-1 mb-1 border-top">
							<td>پیامک</td>
							<td>{{searchCounts.field_sms | number}}</td>
							<td><input type="number" inputmode="numeric" name="fieldSmsSendCount" [(ngModel)]="sendCount.fieldSms"
									min="0" value="0" />
							</td>
							<td><button class="btn btn-blue fs-sm" (click)="send('field', 'Sms', sendCount.fieldSms)"
									[disabled]="!booster.valid || !+(sendCount.fieldSms)">ارسال</button>
							</td>
							<td>{{sentCount.field?.Sms | number}}</td>
						</tr>
						<tr class="pb-1 mb-1 border-top">
							<td>ایمیل</td>
							<td>{{searchCounts.field_email | number}}</td>
							<td><input type="number" inputmode="numeric" name="fieldEmailSendCount" [(ngModel)]="sendCount.fieldEmail"
									min="0" value="0" />
							</td>
							<td><button class="btn btn-blue fs-sm" (click)="send('field', 'Email', sendCount.fieldEmail)"
									[disabled]="!booster.valid || !+(sendCount.fieldEmail)">ارسال</button> </td>
							<td>{{sentCount.field?.Email | number}}</td>
						</tr>
					</table>
				</ng-container>
			</div>
			<div class="py-2 border-bottom border-dark-gray border-2 my-2" [class.x-light-gray-bg]="!view.subscribes">
				<h6 class="btn btn-link fs-lg text-center w-100" (click)="view.subscribes=!view.subscribes">سابسکرایب</h6>
				<ng-container *ngIf="view.subscribes">

					<div class="fs-sm text-center">کلمات کلیدی سمت راست روی نتایج این بخش تاثیری ندارد</div>
					<div class="d-flex mb-1">
						<div class="flex-grow-1 ml-2">
							<input type="text" [(ngModel)]="payload.Criteria.Seeker.JobAlert.Keyword" name="SubscribeSearch"
								placeholder="جستجوی پیشرفته در سابسکرایب ها" />
						</div>
						<div>
							<button class="btn btn-white" [disabled]="!booster.valid || !payload.Criteria.Seeker.JobAlert.Keyword"
								(click)="search('subscribe')">جستجو</button>
						</div>
					</div>
					<table class="w-100 text-center">
						<tr>
							<td></td>
							<td>تعداد</td>
							<td>تعداد ارسال</td>
							<td></td>
							<td>ثبت شده</td>
						</tr>
						<tr class="pb-1 mb-1 border-top">
							<td>پیامک</td>
							<td>{{searchCounts.subscribe_sms | number}}</td>
							<td><input type="number" inputmode="numeric" name="subscribeSmsSendCount"
									[(ngModel)]="sendCount.subscribeSms" min="0" value="0" /> </td>
							<td><button class="btn btn-blue fs-sm" (click)="send('subscribe', 'Sms', sendCount.subscribeSms)"
									[disabled]="!booster.valid || !+(sendCount.subscribeSms)">ارسال</button>
							</td>
							<td>{{sentCount.subscribe?.Sms | number}}</td>
						</tr>
						<tr class="pb-1 mb-1 border-top d-none">
							<td>ایمیل</td>
							<td>{{searchCounts.subscribe_email | number}}</td>
							<td><input type="number" inputmode="numeric" name="subscribeEmailSendCount"
									[(ngModel)]="sendCount.subscribeEmail" min="0" value="0" /> </td>
							<td><button class="btn btn-blue fs-sm" (click)="send('subscribe', 'Email', sendCount.subscribeEmail)"
									[disabled]="!booster.valid || !+(sendCount.subscribeEmail)">ارسال</button> </td>
							<td>{{sentCount.subscribe?.Email | number}}</td>
						</tr>
					</table>
				</ng-container>
			</div>

			<div class="py-2 border-bottom border-dark-gray border-2 my-2" [class.x-light-gray-bg]="!view.najva">
				<h6 class="btn btn-link fs-lg text-center w-100" (click)="view.najva=!view.najva">ارسال نجوا</h6>
				<ng-container *ngIf="view.najva">
					<div class="d-flex justify-content-between align-items-center mb-2">
						<div class="fs-sm f-red">فیلترهای ستون راست تاثیری در ارسال نجوا ندارد. <br>
							در صورتی که هیچ سگمنتی انتخاب نکنید برای همه اعضای نجوا ارسال خواهد شد.
						</div>
						<button class="btn btn-white fs-sm p-1" (click)="fetchNajvaSegments()">دریافت سگمنت ها</button>
					</div>
					<ng-select name="najva-segment" [multiple]="true" [items]="najvaSegments" [virtualScroll]="true"
						bindValue="Account_Id" bindLabel="Label" [(ngModel)]="payload.NajvaSegments" [selectOnTab]="true"
						placeholder="مخاطبان نجوا" class="w-100">
					</ng-select>
					<div class="text-left">
						<button class="btn btn-white" (click)="send('najva', 'Push', 0)">ارسال</button>
					</div>
					<pre dir="ltr" class="text-left overflow-auto d-none" style="max-height: 200px;">
					{{najvaSetting | json}}
				</pre>
				</ng-container>
			</div>
			<div class="fs-sm">
				ممکن است تعداد نهایی در هر بخش کمتر از عدد تعیین شده باشد. گزارش
				را چک کنید.
			</div>
			<div class="d-flex justify-content-between">
				<div>
					<button class="btn btn-white fs-sm" (click)="getSentCount()">دریافت گزارش</button>
				</div>
				<div class="fs-normal">کل پیامک ها: {{sentCount.all?.Sms | number}}</div>
				<div class="fs-normal">کل ایمیل ها: {{sentCount.all?.Email | number}}</div>
			</div>
			<div class="py-2 mt-2 border-top border-2">
				<h5 class="text-center pointer" (click)="showAlerts = !showAlerts">ارسال های ثبت شده ({{alerts?.length}})</h5>
				<div *ngIf="showAlerts">
					<div *ngFor="let alert of alerts" class="rounded-xl m-2 p-2 shadow-kp border border-dark-gray">
						<div class="d-flex justify-content-between">
							<div>زمان ثبت: {{alert.RegisterTime | pdate : '[yy]/[mm]/[dd]-[h]:[mi]'}}</div>
							<div>زمان ارسال: {{alert.SendTime | json}}</div>
							<div>ارسال شده: {{alert.IsSent}}
								<button class="btn btn-link f-red" (confirm)="deleteJobAlert(alert)"
									[class.d-none]="alert.IsSent">حذف</button>
							</div>
							<div>زمان واقعی ارسال: {{alert.SentTime | pdate : '[yy]/[mm]/[dd]-[h]:[mi]'}}</div>
						</div>
						<div class="d-flex justify-content-between">
							<div>کانال ارسال:
								<ng-container [ngSwitch]="alert.Channel">
									<ng-container *ngSwitchCase="0">Push</ng-container>
									<ng-container *ngSwitchCase="1">Sms</ng-container>
									<ng-container *ngSwitchCase="2">Email</ng-container>
								</ng-container>
							</div>
							<div>نوع جستجو: {{alert.SearchType}}</div>
							<div *ngIf="alert.ReceiverCount || alert.Users?.length">تعداد: {{(alert.ReceiverCount ||
								alert.Users?.length) | number}}
								<button class="btn btn-link" (click)="showSeekers(alert);seekersModal.open()">نمایش</button>
							</div>
						</div>
						<div class="d-flex justify-content-between">
							<div>مکان: {{[alert.Criteria?.Seeker?.State, alert.Criteria?.Seeker?.City] | join: '،'}}</div>
							<div>عنوان شغلی:
								{{alert.JobTitles | join : '، ' }}
								{{alert.Criteria?.Seeker?.JobTitles | join : '، ' }}
							</div>
							<div>رشته تحصیلی: <span *ngFor="let item of alert.Criteria?.Seeker?.Fields">{{item}}</span></div>
							<div>سابسکرایب: <span>{{alert.Criteria?.Seeker?.JobAlert?.Keyword}}</span></div>

						</div>
						<div>
							<button class="btn btn-link btn-sm fs-sm" (click)="alert._more=!alert._more">اطلاعات بیشتر</button>
						</div>

						<div dir="ltr" *ngIf="alert._more" class="text-left overflow-auto light-gray-bg border"
							style="max-height: 100px;">
							{{alert|json}}
						</div>
					</div>
				</div>
			</div>

		</div>
	</form>
	<ngx-smart-modal #seekersModal identifier="seekersModal" customClass="full-width">

		<div class="col-12 p-2 border-top" *ngIf="seekers?.length">
			<div style="overflow: auto;" class="h-full-header">
				<div class="row fs-normal dark-gray-bg f-yellow text-center">
					<div class="col-2">نام</div>
					<div class="col-7">مهارت‌ها</div>
					<div class="col-3">رشته تحصیلی</div>
				</div>
				<div class="row fs-sm border-bottom light-yellow-bg-hover" *ngFor="let user of seekers">
					<div class="col-2"><a [routerLink]="['/resume',user.Seeker?.Code]" target="_blank">{{user.Name}}</a></div>
					<div class="col-7">{{user.Seeker.Skills|join:' | ':'Title'}}</div>
					<div class="col-3">{{user.Seeker.Educations|join:' | ':'Field'}}</div>
				</div>
			</div>
		</div>
	</ngx-smart-modal>
</section>